import {
    CloseButton,
    Flex,
    HStack,
} from '@chakra-ui/react';
import * as React from 'react';

import {
    AddIcon,
    CheckCircleIcon,
    EditIcon,
} from '@/imports/ui/chakra/feather';

export const OtherItemsCategoryListActions: React.FC<{
    row: any;
    onEdit: (id: string) => void;
    onAddNew: (id: string) => void;
    onSave: () => void;
    onCancel: () => void;
    editingId?: string | null;
    isSaving?: boolean;
}> = ({ row, onEdit, onAddNew, onSave, onCancel, editingId, isSaving }) => {

    return (
        <HStack spacing={2} justify="flex-start">
            <Flex align="center" justify="center" columnGap={5} pointerEvents={isSaving?'none':'initial'}>
                {editingId === row._id ?(
                    <>
                        <CloseButton boxSize="18px" color="primary.500" cursor={!isSaving?'pointer':'not-allowed'} onClick={() => onCancel()} />
                        <CheckCircleIcon boxSize="18px" color="primary.500" cursor={!isSaving?'pointer':'not-allowed'} onClick={() => onSave()} />
                    </>
                ) : (
                    <>
                        <EditIcon boxSize="18px" color="primary.500" cursor={'pointer'} onClick={() => onEdit(row._id)} />
                        {/* <AddIcon boxSize="18px" color="primary.500" cursor={'pointer'} onClick={() => onAddNew(row._id)} /> */}
                    </>
                )}
            </Flex>
        </HStack>
    );
};
